import { useState } from "react";
import api from "src/services/api"

export function useFinanceCheck () {


    const [salesData, setSalesData] = useState([]);
    const [financeData, setFinanceData] = useState<Record<string,any>[]>([]);


    const loadGlobal = async (project_id) => {


        const checkSaldo = await api.get(`/check-saldo-static/${project_id}/json`);
        const sales = await api.get(`/sales`, { params: { limitItems: 100000, where: { project_id: project_id}}});


        setSalesData(sales?.data?.rows);
        setFinanceData(checkSaldo?.data?.rows);
        return;

    }

    const checkSalesNotFoundInSaldo = (sales, financeCheck) => {


        const salesPaid = sales?.filter(i => i?.payment_status_id === 'paid' && i?.total > 0);


        const salesNotFound : Array<Record<string,any>> = [];

        salesPaid?.map( sale => {

            const index = financeCheck?.findIndex( check => check?.hash === sale?.sale_hash);

            if(index < 0){

                salesNotFound.push(sale);
            }

        })



        return salesNotFound;


    }



        const checkSalesNotPaidInSaldo = (sales, financeCheck) => {


        const salesNotPaid = sales?.filter(i => i?.payment_status_id !== 'paid' && i?.total > 0);


        const salesNotFound : Array<Record<string,any>> = [];

        financeCheck?.map( sale => {

            const index = salesNotPaid?.findIndex( check => check?.sale_hash === sale?.hash);

            if(index >= 0){

                salesNotFound.push(sale);
            }

        })



        return salesNotFound;


    }


    const listOperationTypeRawPremade = (checkFinance) => {


        const list = [
            { label : 'Crédito', total: 0, net_total: 0, antecipation_tax : 0 },
            { label : 'Estorno', total: 0, net_total: 0, antecipation_tax : 0 },
            { label : 'ChargeBack', total: 0, net_total: 0, antecipation_tax : 0 },
            { label : 'Saque', total: 0, net_total: 0, antecipation_tax : 0 }




        ]

        const operationOption : any = [];

        checkFinance?.map( item => {

            const index = operationOption?.findIndex( i => i?.label === item?.operation_type);


            if(index < 0){
                operationOption.push({ label: item?.operation_type, value: item?.operation_type_raw})
            }

        })


       operationOption.sort((a,b) => a?.label < b?.label ? -1: a?.label > b?.label ? 1 : 0)


       return operationOption;

    }
       


    const listOperationTypeRaw = (checkFinance) => {

        const operationOption : any = [];

        checkFinance?.map( item => {

            const index = operationOption?.findIndex( i => i?.label === item?.operation_type);


            if(index < 0){
                operationOption.push({ label: item?.operation_type, value: item?.operation_type_raw})
            }

        })


       operationOption.sort((a,b) => a?.label < b?.label ? -1: a?.label > b?.label ? 1 : 0)


       return operationOption;

    }


         const checkByOperation = ( financeCheck ) => {

                const list = listOperationTypeRaw(financeCheck)

       
let x = 0;

while(x < list?.length ){

    const item = list[x];

    const raw = financeCheck?.filter( i => i?.operation_type === item?.label);

    raw?.map( line => {
        if(!list[x].total){
            list[x].total = 0;
        }
             if(!list[x].saldo){
            list[x].saldo = 0;
        }
  if(!list[x].net_total){
            list[x].net_total = 0;
        }
  if(!list[x].antecipation_gap){
            list[x].antecipation_gap = 0;
        }

          if(!list[x].operation_fee){
            list[x].operation_fee = 0;
        }

        list[x].total += parseInt(line?.total,10)
        list[x].net_total += parseInt(line?.net_total,10)
list[x].antecipation_gap += parseInt(line?.antecipation_gap,10);
list[x].operation_fee += parseInt(line?.operation_fee,10);


    })




    x += 1;
}

let net = 0;

let y = 0;
list.sort((a,b) => a?.total > b?.total ? -1 : a?.total < b?.total ? 1 : 0 )
while(y < list?.length ){

    list?.map( item => {
    net += item?.net_total;
    item.saldo =  parseInt(net?.toString(),10);


})

    y+=1;
}





 return list;
        


    }

    const filterOperationOptions = (checkFinance, operation_option) => {

         const check = checkFinance?.sort( i => i?.operation_type_raw === operation_option);

         let total = 0;
         let net_total = 0;

         check?.map( item => {


            total += parseInt(item?.total,10);
            net_total += parseInt(item?.net_total,10);


         })

         return {total, net_total, list : check}

    }


       


 




    return {loadGlobal, salesData, financeData,  checkSalesNotFoundInSaldo, listOperationTypeRaw, checkSalesNotPaidInSaldo, checkByOperation }
}